import { INSTAT_STATS } from './stats-filter';

export function filterStatisticsFromResponse(response: any, instatStatistics: any) {
	if (instatStatistics && instatStatistics.value) {
		return response.filter((item: any) => INSTAT_STATS[instatStatistics.value].includes(item.id));
	}
}
